import { createParamString, slugify } from '@surfline/web-common';

export const rewindSharePath = ({
  spotName,
  spotId,
  currentTimestamp,
  camId,
}: {
  spotName: string;
  spotId: string;
  currentTimestamp: string | null;
  camId: string | null;
}) =>
  `/share/surf-report/${slugify(spotName)}/${spotId}/rewind?${createParamString({
    ...(currentTimestamp && { currentTimestamp }),
    ...(camId && { camId }),
  })}`;

export default rewindSharePath;
